module.exports = "this is admin app home page\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+admin-app/+home/home.component.html
// module id = 574
// module chunks = 0